var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({ref:"input",staticClass:"reseller-input",class:_vm.inputSize ? 'reseller-input--' + _vm.inputSize : '',attrs:{"type":"text"},on:{"input":_vm.handleInput}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }